var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("article", { staticClass: "media" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "media-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.getters.hasAnyRole([
                  "lyris",
                  "admin",
                  _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                ]),
                expression:
                  "$store.getters.hasAnyRole(['lyris','admin', constants.STRINGS.ROLES.LYRIS_SOPORTE.ID])",
              },
            ],
            staticClass: "field is-grouped is-pulled-right",
          },
          [
            _c(
              "p",
              { staticClass: "control" },
              [
                _c(
                  "b-tooltip",
                  { attrs: { label: "Editar", position: "is-left" } },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "button is-black is-outlined",
                        attrs: {
                          to: {
                            name: "organizacionEditar",
                            params: { idOrganization: _vm.idOrganization },
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-edit" })]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "title is-1" }, [
          _vm._v(_vm._s(_vm.organizacion.razon_social)),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "subtitle is-6 is-mono" }, [
          _vm._v(_vm._s(_vm.organizacion.slug)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("table", { staticClass: "table is-narrow" }, [
            _c("tbody", [
              _c("tr", [
                _c("th", { attrs: { width: "150" } }, [_vm._v("CUIT")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.organizacion.cuit
                        ? _vm.organizacion.cuit
                        : "Sin Datos"
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", { attrs: { width: "150" } }, [_vm._v("Dirección")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.organizacion.direccion
                        ? _vm.organizacion.direccion
                        : "Sin Datos"
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", { attrs: { width: "150" } }, [_vm._v("Telefono")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.organizacion.telefono
                        ? _vm.organizacion.telefono
                        : "Sin Datos"
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", { attrs: { width: "150" } }, [_vm._v("Email")]),
                _vm._v(" "),
                _vm.organizacion.email
                  ? _c("td", [
                      _c(
                        "a",
                        { attrs: { href: "mailto:" + _vm.organizacion.email } },
                        [_vm._v(_vm._s(_vm.organizacion.email))]
                      ),
                    ])
                  : _c("td", [_vm._v("Sin datos")]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("figure", { staticClass: "media-left" }, [
      _c("i", { staticClass: "fas fa-building fa-4x fa-fw" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }